import React from 'react'
import OfficeSvg from 'images/modules/Manage/i-menu-personnel.svg?raw'

export { default as OfficeUrl } from 'images/modules/Manage/i-menu-personnel.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: OfficeSvg}} />
)
